import script from "./iosInstruction.vue?vue&type=script&lang=ts&setup=true"
export * from "./iosInstruction.vue?vue&type=script&lang=ts&setup=true"

import "./iosInstruction.vue?vue&type=style&index=0&id=60edadd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60edadd2"]])

export default __exports__